/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.26",
    versionName: "0.8.0-nightly.2026.10.26",
    versionChannel: "nightly",
    buildDate: "2026-10-26T00:15:10.871Z",
    commitHash: "f6ee2b04825d7080c42c87990e9d594314a396bf",
};
